/* eslint-disable */

export const onUpdateSumBySourceExportResults = /* GraphQL */ `
  subscription OnUpdateSumBySourceExportResults(
    $filter: ModelSubscriptionSumBySourceExportResultsFilterInput
  ) {
    onUpdateSumBySourceExportResults(filter: $filter) {
      id
      client_id
      run_config
      status
      s3_key
      signed_s3_url
      errors
      saved_dt
      createdAt
      updatedAt
    }
  }
`;
